import { Modal } from "antd";
import { ExclamationCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function InventoryDependencyModal({
  open,
  title,
  context = "INGREDIENT",
  dependentFoods = [],
  dependentSetMenus = [],
  dependentOrders = [],
  handleConfirm = () => {},
  handleCancel = () => {},
}) {
  const navigate = useNavigate();

  return (
    <Modal
      maskClosable={false}
      open={open}
      title={<p className="text-md font-p_medium w-[calc(100%-20px)]">{title}</p>}
      onOk={handleConfirm}
      onCancel={handleCancel}
      okText="Confirm"
      cancelText="Close"
      width={600}
      okButtonProps={{ style: { backgroundColor: "black", color: "white", fontWeight: 700 } }}
      cancelButtonProps={{ style: { backgroundColor: "#FCBD10", color: "black", fontWeight: 700 } }}
    >
      <div className="my-3">
        {Array.isArray(dependentFoods) && dependentFoods.length > 0 && (
          <div>
            <h1 className="text-sm text-black font-p_semibold py-2">Foods</h1>
            {dependentFoods.map((food) => (
              <div
                key={food.id}
                className="w-full flex items-center justify-between py-2 px-3
                border border-[1px] border-[#FCBD10] rounded-lg mb-1.5 cursor-pointer font-medium"
                onClick={() => navigate(`/inventory/recipe/${food.id}/edit?recipeType=FOOD`)}
              >
                <p className="max-w-[calc(100%-50px)] break-words">{food.name}</p>
                <RightCircleOutlined />
              </div>
            ))}
          </div>
        )}

        {Array.isArray(dependentSetMenus) && dependentSetMenus.length > 0 && (
          <div>
            <h1 className="text-sm text-black font-p_semibold">Setmenus</h1>
            {dependentSetMenus.map((setMenu) => (
              <div
                key={setMenu.id}
                className="w-full flex items-center justify-between py-2 px-3
                border border-[1px] border-[#FCBD10] rounded-lg mb-1.5 cursor-pointer font-medium"
                onClick={() => context === 'ITEM' ? void 0 : navigate(`/inventory/recipe/${setMenu.id}/edit?recipeType=ADD_ONS`)}
              >
                <p className="max-w-[calc(100%-50px)] break-words">{setMenu.name}</p>
                {context !== "ITEM" && <RightCircleOutlined />}
              </div>
            ))}
          </div>
        )}

        {Array.isArray(dependentOrders) && dependentOrders.length > 0 && (
          <div>
            <h1 className="text-sm text-black font-p_semibold">Orders</h1>
            {dependentOrders.map((order) => (
              <div
                key={order.id}
                className="w-full flex items-center justify-between py-2 px-3
                border border-[1px] border-[#FCBD10] rounded-lg mb-1.5 cursor-pointer font-medium"
                onClick={() => navigate(`/order/${order.id}/details`)}
              >
                <p className="max-w-[calc(100%-50px)] break-words">{order.orderNumber}</p>
                <RightCircleOutlined />
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}

export default InventoryDependencyModal;
